import {Modal, Vote} from "../../components";
import {Component} from "react";
import styles from './Voting.module.scss';
import cn from "classnames";

const results = [
    {
        id: 1, iblock: 38496, text: 'ПОБЕДИТЕЛЬ - ДВОЙНАЯ ИГРА: 267', desc: 'Даник Шреков спокойно покупал номера для своих друзей, чтобы у тех были личные аккаунты с персонажами вроде Росомахи и Супермена. Но однажды Даника взломали и начали его шантажировать. Злоумышленник требовал отдать ему аккаунт — тогда никто не пострадает. Но вдруг появился ещё один взломщик с точно такими же требованиями. Чтобы разобраться со вторым, первый попросил пустить его в аккаунт. Путём переговоров было достигнуто соглашение, и за это Даник Шреков выполнил требования и отдал свой аккаунт первому злоумышленнику. Только вот злоумышленником его сложно назвать — им оказался друг Даника! Теперь парень никому не доверяет свои логины и пароли, а к близкому окружению относится с недоверием. И периодически параноит.'
    },
    {
        id: 2, iblock: 38497, text: 'ОХ УЖ ЭТИ СОЦСЕТИ: 147', desc: 'Как-то раз решила я зарегистрироваться в одной популярной соцсети для поиска пары. Вижу в мессенджере: «Добрый вечер». На следующую ночь история повторяется. Решаюсь ответить ему: «Знакомы ли мы?» Он отвечает, что нет и пытается познакомиться. ЧЕРЕЗ МИНУТУ, во соцсетях сообщение: «Добрый вечер». Тут я уже напряглась. Через какую-то нейросеть чувак нашел все мои контакты. Парень заблокирован везде. Напоследок он ещё написал в другом мессенджере, но там он тоже сразу был заблокирован. Вопрос: почему не все парни такие целеустремленные, как этот?))'
    },
    {
        id: 3, iblock: 38498, text: 'РОКОВАЯ НАКРУТКА: 180', desc: 'Однажды я решил накрутить подписчиков для продвижения аккаунта через один непроверенный сайт. Через пару дней решил проверить свой аккаунт и заметил предупреждение, что его взломали. Причём все три аккаунта. Вдруг я понял, что у всех у них одинаковые пароли и все они были взломаны после того, как я сам дал мои личные данные, чтобы накрутить подписчиков. Вот так я потерял все свои аккаунты.'
    }
]

const kaspersky = 'https://allsoft.kaspersky.ru/basket/add/4669584?clear=Y&reseller=kl-ru_22ru-2X2_pro_ona_oth__onl_b2c_2x2_lnk_2x2___kis___';

export class Voting extends Component {
    state = {
        show: false,
        current: null
    }

    toggleModal = () => {
        this.setState(({show}) => ({ show: !show }));
    }

    showModal = (type) => {
        if (type === 'success') {
            this.setState({ current: 0 });
        } else if (type === 'error') {
            this.setState({ current: 1 });
        } else if (type === 'retry') {
            this.setState({ current: 2 });
        } else if (type === 'closed') {
            this.setState({ current: 3 });
        }

        this.toggleModal();
    }

    voteList = results.map(item => {
        return <Vote key={item.id} desc={item.desc} handler={this.showModal} id={item.id} text={item.text} iblock={item.iblock} status={Number(this.props.cookie) === item.iblock}/>
    })

    render() {
        const {current} = this.state;
        const textList = ['голос учтен', 'произошла ошибка', 'вы уже проголосовали', 'голосование окончено'];

        return (
            <div className={styles.voting}>
                {this.voteList}
                <Modal className="no-close" open={this.state.show} closer={this.toggleModal}>
                    <div className={cn(styles.modal, current === 1 || current === 3 ? styles.error : current === 2 ? styles.retry : '')}>
                        <div className={styles.close} onClick={this.toggleModal}/>
                        <div className={styles.block}>
                            <div className={styles.header}>
                                <div className={styles.title}>{textList[current]}</div>
                                <div className={styles.desc}>
                                    {current === 1 ? <span>Что-то пошло не так. Попробуйте проголосовать повторно</span> : <span>Пройди по <a
                                        href="https://t.me/addstickers/cybercringe2x2" target="_blank" rel="nofollow noreferrer">ссылке</a> чтобы получить кринжепак кринжестикеров</span>}
                                </div>
                            </div>
                            <div className={styles.footer}>
                                <div className={styles.text}>А еще не забудь активировать защиту от киберкринжа</div>
                                <a href={kaspersky} className={styles.button} target="_blank" rel="nofollow noreferrer">Активировать</a>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}